import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { FrameCategory } from '@photobooth/types';

export function useFrameCategories() {
  const [frameCategories, setFrameCategories] = useState<FrameCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFrameCategories = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.frameCategories.getAll();
      if (response.success && response.data) {
        const data = (response.data as { data?: FrameCategory[] })?.data || response.data;
        setFrameCategories(Array.isArray(data) ? (data as FrameCategory[]) : []);
      } else {
        setError('Failed to fetch frame categories');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch frame categories');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFrameCategories();
  }, []);

  return {
    frameCategories,
    isLoading,
    error,
    refetch: fetchFrameCategories,
  };
}
